import toast from 'react-hot-toast';
import { computed, makeObservable } from 'mobx';
import { stores } from 'state/stores';
import API from 'utils/API';
import { formatWorkoutTimestamp } from 'utils/dates';
import { WorkoutCellInnerProps } from './types';
import { calculateWorkoutContent, calculateWorkoutStats } from './utils';
import { sendEvent } from 'utils/events';
import { copyToClipboard } from 'utils/clipboard';
import { UserWorkout } from 'hevy-shared';

export class WorkoutCellViewModel {
  workout: UserWorkout;

  constructor(workout: UserWorkout) {
    makeObservable(this, {
      data: computed,
    });

    this.workout = workout;
  }

  onLikeWorkout = async () => {
    await stores.workouts.likeWorkout(this.workout.id);
    stores.workouts.fetchWorkout(this.workout.id);
  };

  onCommentSend = async (comment: string) => {
    if (comment.length === 0) return;

    await API.postWorkoutComment(this.workout.id, comment);
    stores.workouts.fetchWorkout(this.workout.id);
  };

  onCommentDelete = async (commentId: number) => {
    await API.deleteWorkoutComment(commentId);
    stores.workouts.fetchWorkout(this.workout.id);
  };

  get data(): WorkoutCellInnerProps {
    const w = this.workout;

    return {
      workout: w,
      key: w.id,
      workoutId: w.id,
      shortId: w.short_id ?? undefined,
      title: w.name,
      description: w.description,
      username: w.username,
      date: formatWorkoutTimestamp(w),
      profileImage: w.profile_image,
      currentUserImage: stores.account.profile_pic,
      stats: calculateWorkoutStats(w, stores.userPreferences),
      content: calculateWorkoutContent(w),
      onShare: () => {
        sendEvent('workoutCell_sharePress');
        copyToClipboard(`https://${location.hostname}/workout/${w.id}`);
        toast.success('Copied link to clipboard');
      },
      onCommentSend: this.onCommentSend,
      comments: stores.workouts.workouts[this.workout.id]?.comments || [],
      commentCount: w.comment_count,
      isLiked: w.is_liked_by_user,
      likeCount: w.like_count,
      onLike: this.onLikeWorkout,
      onCommentDelete: this.onCommentDelete,
      privateWorkout: w.is_private,
      isCoached: stores.account.isActivelyCoached,
    };
  }
}
